(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Contact2ForUser', Contact2ForUser);

    Contact2ForUser.$inject = ['$resource'];
    function Contact2ForUser ($resource) {
        var resourceUrl =  'api/contact/user';

        return $resource(resourceUrl, {}, {

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();
